import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './soc-compliance.css'

const SOCCompliance = (props) => {
  return (
    <div className="soc-compliance-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="SOC-Compliance - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/soc-compliance"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section soc-compliance-hero-section">
        <div className="hero-background-wrapper">
          <img
            alt="Cybersecurity compliance expert monitoring systems"
            src="https://images.pexels.com/photos/5380594/pexels-photo-5380594.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="soc-compliance-hero-background-image hero-background-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="soc-compliance-hero-content-wrapper">
          <div className="hero-content soc-compliance-hero-content">
            <div className="soc-compliance-hero-badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
              <span>SOC Compliance Experts</span>
            </div>
            <h1 className="hero-title soc-compliance-hero-title">
              Enterprise-Grade SOC Compliance Services
            </h1>
            <p className="soc-compliance-hero-subtitle hero-subtitle">
              Achieve audit readiness with comprehensive SOC 2 and SOC 3
              compliance management. Expert-led assessments, control mapping,
              and ongoing monitoring to ensure your organization meets the
              highest trust service criteria.
            </p>
            <div className="hero-cta-group soc-compliance-hero-cta-group">
              <a href="#contact">
                
                  <a className="btn-primary btn btn-lg" href="https://outlook.office.com/book/CysigilNetwork@cysigil.com/?ismsaljsauthenabled">
                    <span>Talk to an Expert</span>
                  </a>
                
              </a>
              <a href="#assessment">
                <div className="btn btn-lg btn-outline">
                <span style={{ color: 'black' }}>Request Assessment</span>
                </div>
              </a>
            </div>
            <div className="soc-compliance-hero-trust-indicators">
              <div className="hero-trust-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>SOC 2 Type II Certified</span>
              </div>
              <div className="hero-trust-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
                <span>100+ Engagements</span>
              </div>
              <div className="hero-trust-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 6v6l4 2"></path>
                    <circle r="10" cx="12" cy="12"></circle>
                  </g>
                </svg>
                <span>45-Day Avg Delivery</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="features-overview-section">
        <div className="features-overview-container">
          <div className="features-overview-header">
            <h2 className="section-title">
              Comprehensive SOC Compliance Management
            </h2>
            <p className="section-subtitle">
              Our holistic approach ensures your organization achieves and
              maintains SOC compliance through structured assessments, control
              implementation, and continuous monitoring.
            </p>
          </div>
          <div className="features-overview-grid">
            <div className="features-overview-card">
              <div className="features-overview-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="features-overview-card-title">
                SOC Readiness Assessment
              </h3>
              <p className="features-overview-card-text">
                Comprehensive evaluation of your current control environment
                against SOC 2 Trust Service Criteria. We identify gaps, assess
                risks, and provide a detailed readiness roadmap to ensure your
                organization is prepared for a successful audit.
              </p>
              <ul className="features-overview-list">
                <li>
                  <span>Gap analysis and maturity scoring</span>
                </li>
                <li>
                  <span>Control effectiveness evaluation</span>
                </li>
                <li>
                  <span>Risk prioritization framework</span>
                </li>
                <li>
                  <span>Pre-audit readiness validation</span>
                </li>
              </ul>
            </div>
            <div className="features-overview-card">
              <div className="features-overview-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="features-overview-card-title">
                SOC Reporting Services
              </h3>
              <p className="features-overview-card-text">
                Professional preparation and management of SOC 1, SOC 2 Type I
                &amp; Type II, and SOC 3 reports. Our experts coordinate with
                auditors, gather evidence, and ensure accurate documentation of
                your control environment for regulatory and client requirements.
              </p>
              <ul className="features-overview-list">
                <li>
                  <span>Type I and Type II report preparation</span>
                </li>
                <li>
                  <span>Evidence collection and organization</span>
                </li>
                <li>
                  <span>Auditor liaison and coordination</span>
                </li>
                <li>
                  <span>Management assertion development</span>
                </li>
              </ul>
            </div>
            <div className="features-overview-card">
              <div className="features-overview-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M3 3v16a2 2 0 0 0 2 2h16M7 16h8m-8-5h12M7 6h3"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="features-overview-card-title">
                Ongoing Compliance Management
              </h3>
              <p className="features-overview-card-text">
                Continuous monitoring and maintenance of your SOC compliance
                posture. We implement automated control testing, provide
                quarterly reviews, and ensure your organization maintains audit
                readiness throughout the compliance lifecycle.
              </p>
              <ul className="features-overview-list">
                <li>
                  <span>Continuous control monitoring</span>
                </li>
                <li>
                  <span>Quarterly compliance reviews</span>
                </li>
                <li>
                  <span>Change management integration</span>
                </li>
                <li>
                  <span>Real-time dashboard reporting</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="process-steps-section">
        <div className="process-steps-container">
          <div className="process-steps-header">
            <h2 className="section-title">SOC Assessment Methodology</h2>
            <p className="section-subtitle">
              Our proven five-phase approach determines your current maturity
              level and identifies specific gaps against SOC Trust Service
              Criteria, providing a clear path to certification.
            </p>
          </div>
          <div className="process-steps-wrapper">
            <div className="soc-compliance-process-step">
              <div className="process-step-number">
                <span>01</span>
              </div>
              <div className="process-step-content">
                <div className="process-step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <circle r="6" cx="12" cy="12"></circle>
                      <circle r="2" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
                <h3 className="process-step-title">Scoping &amp; Planning</h3>
                <p className="process-step-description">
                  Define audit boundaries, identify in-scope systems and
                  processes, and establish Trust Service Criteria applicable to
                  your organization&apos;s service commitments.
                </p>
              </div>
              <div className="process-step-connector"></div>
            </div>
            <div className="soc-compliance-process-step">
              <div className="process-step-number">
                <span>02</span>
              </div>
              <div className="process-step-content">
                <div className="process-step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="m15.228 16.852l-.923-.383m.923 2.679l-.923.383M16 2v4m.47 8.305l.382.923m0 5.544l-.383.924m2.679-6.468l.383-.923m-.001 7.391l-.382-.924m1.624-3.92l.924-.383m-.924 2.679l.924.383M21 10.592V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6M3 10h18M8 2v4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <circle r="3" cx="18" cy="18"></circle>
                  </svg>
                </div>
                <h3 className="process-step-title">Control Inventory</h3>
                <p className="process-step-description">
                  Catalog existing controls across all five Trust Service
                  Categories: security, availability, processing integrity,
                  confidentiality, and privacy.
                </p>
              </div>
              <div className="process-step-connector"></div>
            </div>
            <div className="soc-compliance-process-step">
              <div className="process-step-number">
                <span>03</span>
              </div>
              <div className="process-step-content">
                <div className="process-step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                      <path d="m19 9l-5 5l-4-4l-3 3"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="process-step-title">Gap Analysis</h3>
                <p className="process-step-description">
                  Assess control design and operational effectiveness against
                  SOC requirements, identifying deficiencies and rating gaps by
                  severity and remediation complexity.
                </p>
              </div>
              <div className="process-step-connector"></div>
            </div>
            <div className="soc-compliance-process-step">
              <div className="process-step-number">
                <span>04</span>
              </div>
              <div className="process-step-content">
                <div className="process-step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="process-step-title">Risk Prioritization</h3>
                <p className="process-step-description">
                  Evaluate identified gaps based on audit impact, business risk,
                  and implementation effort to create a prioritized remediation
                  roadmap with realistic timelines.
                </p>
              </div>
              <div className="process-step-connector"></div>
            </div>
            <div className="soc-compliance-process-step">
              <div className="process-step-number">
                <span>05</span>
              </div>
              <div className="process-step-content">
                <div className="process-step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76M12 8v4m0 4h.01"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="process-step-title">Readiness Validation</h3>
                <p className="process-step-description">
                  Conduct pre-audit validation testing to verify control
                  implementation, validate evidence sufficiency, and confirm
                  organizational readiness for formal SOC examination.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="control-mapping-section">
        <div className="control-mapping-container">
          <div className="control-mapping-header">
            <h2 className="section-title">SOC Control Framework Structure</h2>
            <p className="section-subtitle">
              Our control mapping methodology ensures complete coverage across
              all Trust Service Criteria with clearly defined scope,
              responsibility assignment, and testing procedures.
            </p>
          </div>
          <div className="control-mapping-table-wrapper">
            <table className="control-mapping-table">
              <thead>
                <tr>
                  <th>
                    <span>Trust Service Category</span>
                  </th>
                  <th>
                    <span>Control Domain</span>
                  </th>
                  <th>
                    <span>Control Owner</span>
                  </th>
                  <th>
                    <span>Testing Frequency</span>
                  </th>
                  <th>
                    <span>Evidence Type</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span className="control-mapping-badge">Security</span>
                  </td>
                  <td>
                    <span>Access Control &amp; Authentication</span>
                  </td>
                  <td>
                    <span>IT Security Team</span>
                  </td>
                  <td>
                    <span>Quarterly</span>
                  </td>
                  <td>
                    <span>System Logs, IAM Policies</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="control-mapping-badge">Security</span>
                  </td>
                  <td>
                    <span>Network &amp; Infrastructure Security</span>
                  </td>
                  <td>
                    <span>Network Operations</span>
                  </td>
                  <td>
                    <span>Monthly</span>
                  </td>
                  <td>
                    <span>Firewall Rules, IDS Reports</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="control-mapping-badge">Security</span>
                  </td>
                  <td>
                    <span>Change Management</span>
                  </td>
                  <td>
                    <span>DevOps &amp; Engineering</span>
                  </td>
                  <td>
                    <span>Per Change</span>
                  </td>
                  <td>
                    <span>Change Tickets, Approvals</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="control-mapping-badge">Availability</span>
                  </td>
                  <td>
                    <span>System Monitoring &amp; Performance</span>
                  </td>
                  <td>
                    <span>SRE Team</span>
                  </td>
                  <td>
                    <span>Continuous</span>
                  </td>
                  <td>
                    <span>Uptime Reports, Alerts</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="control-mapping-badge">Availability</span>
                  </td>
                  <td>
                    <span>Backup &amp; Disaster Recovery</span>
                  </td>
                  <td>
                    <span>Infrastructure Team</span>
                  </td>
                  <td>
                    <span>Weekly</span>
                  </td>
                  <td>
                    <span>Backup Logs, DR Tests</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="control-mapping-badge">
                      Processing Integrity
                    </span>
                  </td>
                  <td>
                    <span>Data Processing Controls</span>
                  </td>
                  <td>
                    <span>Application Team</span>
                  </td>
                  <td>
                    <span>Per Process Cycle</span>
                  </td>
                  <td>
                    <span>Transaction Logs, Reconciliations</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="control-mapping-badge">
                      Confidentiality
                    </span>
                  </td>
                  <td>
                    <span>Data Encryption &amp; Protection</span>
                  </td>
                  <td>
                    <span>Security Architecture</span>
                  </td>
                  <td>
                    <span>Quarterly</span>
                  </td>
                  <td>
                    <span>Encryption Standards, Key Management</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="control-mapping-badge">Privacy</span>
                  </td>
                  <td>
                    <span>Personal Data Handling</span>
                  </td>
                  <td>
                    <span>Privacy Officer</span>
                  </td>
                  <td>
                    <span>Semi-Annual</span>
                  </td>
                  <td>
                    <span>Privacy Policies, Data Inventories</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="control-mapping-badge">Security</span>
                  </td>
                  <td>
                    <span>Incident Response &amp; Management</span>
                  </td>
                  <td>
                    <span>Security Operations</span>
                  </td>
                  <td>
                    <span>Per Incident</span>
                  </td>
                  <td>
                    <span>Incident Reports, Response Logs</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="control-mapping-badge">Security</span>
                  </td>
                  <td>
                    <span>Vendor Risk Management</span>
                  </td>
                  <td>
                    <span>Procurement &amp; Legal</span>
                  </td>
                  <td>
                    <span>Annual</span>
                  </td>
                  <td>
                    <span>Vendor Assessments, Contracts</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="control-mapping-badge">Security</span>
                  </td>
                  <td>
                    <span>Security Awareness Training</span>
                  </td>
                  <td>
                    <span>Human Resources</span>
                  </td>
                  <td>
                    <span>Annual</span>
                  </td>
                  <td>
                    <span>Training Records, Certificates</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="control-mapping-badge">Availability</span>
                  </td>
                  <td>
                    <span>Capacity Planning</span>
                  </td>
                  <td>
                    <span>Infrastructure Team</span>
                  </td>
                  <td>
                    <span>Quarterly</span>
                  </td>
                  <td>
                    <span>Capacity Reports, Forecasts</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="soc-compliance-deliverables-section">
        <div className="deliverables-container">
          <div className="deliverables-header">
            <h2 className="section-title">
              Comprehensive SOC Compliance Artifacts
            </h2>
            <p className="section-subtitle">
              Every engagement delivers production-ready documentation designed
              to streamline your audit process and demonstrate control
              effectiveness to auditors and stakeholders.
            </p>
          </div>
          <div className="deliverables-grid">
            <div className="soc-compliance-deliverables-card">
              <div className="deliverables-card-image">
                <img
                  alt="Control matrix documentation review"
                  src="https://images.pexels.com/photos/7793173/pexels-photo-7793173.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
                <div className="deliverables-card-overlay"></div>
              </div>
              <div className="deliverables-card-content">
                <div className="deliverables-card-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M3 3v16a2 2 0 0 0 2 2h16M7 16h8m-8-5h12M7 6h3"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="deliverables-card-title">Control Matrices</h3>
                <p className="deliverables-card-description">
                  Detailed mapping of all implemented controls to SOC Trust
                  Service Criteria with design descriptions, testing procedures,
                  and operational evidence requirements.
                </p>
              </div>
            </div>
            <div className="soc-compliance-deliverables-card">
              <div className="deliverables-card-image">
                <img
                  alt="Gap analysis documentation"
                  src="https://images.pexels.com/photos/16282318/pexels-photo-16282318.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
                <div className="deliverables-card-overlay"></div>
              </div>
              <div className="deliverables-card-content">
                <div className="deliverables-card-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76M12 8v4m0 4h.01"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="deliverables-card-title">
                  Gap Assessment Report
                </h3>
                <p className="deliverables-card-description">
                  Comprehensive analysis of control deficiencies with severity
                  ratings, business impact assessments, and specific
                  recommendations for remediation.
                </p>
              </div>
            </div>
            <div className="soc-compliance-deliverables-card">
              <div className="deliverables-card-image">
                <img
                  alt="Roadmap planning and timeline"
                  src="https://images.pexels.com/photos/7793675/pexels-photo-7793675.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
                <div className="deliverables-card-overlay"></div>
              </div>
              <div className="deliverables-card-content">
                <div className="deliverables-card-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M8 2v4m8-4v4"></path>
                      <rect x="3" y="4" rx="2" width="18" height="18"></rect>
                      <path d="M3 10h18"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="deliverables-card-title">Remediation Roadmap</h3>
                <p className="deliverables-card-description">
                  Prioritized implementation plan with phased timelines,
                  resource requirements, and milestone tracking to achieve audit
                  readiness within target dates.
                </p>
              </div>
            </div>
            <div className="soc-compliance-deliverables-card">
              <div className="deliverables-card-image">
                <img
                  alt="Executive presentation materials"
                  src="https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
                <div className="deliverables-card-overlay"></div>
              </div>
              <div className="deliverables-card-content">
                <div className="deliverables-card-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <circle r="6" cx="12" cy="12"></circle>
                      <circle r="2" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
                <h3 className="deliverables-card-title">Executive Summary</h3>
                <p className="deliverables-card-description">
                  Board-ready presentation summarizing compliance posture, key
                  findings, risk exposure, and strategic recommendations for
                  executive stakeholders.
                </p>
              </div>
            </div>
            <div className="soc-compliance-deliverables-card">
              <div className="deliverables-card-image">
                <img
                  alt="Policy documentation and procedures"
                  src="https://images.pexels.com/photos/5716001/pexels-photo-5716001.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
                <div className="deliverables-card-overlay"></div>
              </div>
              <div className="deliverables-card-content">
                <div className="deliverables-card-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="deliverables-card-title">Policy Templates</h3>
                <p className="deliverables-card-description">
                  Audit-ready policy and procedure documentation covering all
                  required control domains, customized to your operational
                  environment and business model.
                </p>
              </div>
            </div>
            <div className="soc-compliance-deliverables-card">
              <div className="deliverables-card-image">
                <img
                  alt="Training and knowledge transfer session"
                  src="https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
                <div className="deliverables-card-overlay"></div>
              </div>
              <div className="deliverables-card-content">
                <div className="deliverables-card-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                      <circle r="4" cx="9" cy="7"></circle>
                    </g>
                  </svg>
                </div>
                <h3 className="deliverables-card-title">Training Materials</h3>
                <p className="deliverables-card-description">
                  Comprehensive training guides and workshops for control owners
                  and audit coordinators to ensure organizational readiness and
                  knowledge transfer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="soc-compliance-timeline-section">
        <div className="timeline-background-wrapper">
          <div className="timeline-background-overlay"></div>
        </div>
        <div className="timeline-content-wrapper">
          <div className="soc-compliance-timeline-header">
            <h2 className="section-title">
              SOC Compliance Engagement Timeline
            </h2>
            <p className="section-subtitle">
              Our structured engagement process takes you from initial
              assessment through final SOC report delivery and ongoing
              monitoring handoff, typically completing within 12-16 weeks.
            </p>
          </div>
          <div className="timeline-rail-wrapper">
            <div className="timeline-rail">
              <div className="timeline-event">
                <div className="timeline-event-marker">
                  <div className="timeline-event-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7l-7 7"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="timeline-event-content">
                  <div className="timeline-event-time">
                    <span>Week 1-2</span>
                  </div>
                  <h3 className="timeline-event-title">Project Kickoff</h3>
                  <p className="timeline-event-description">
                    Stakeholder alignment, scope finalization, document request
                    list, and team onboarding with project management
                    infrastructure setup.
                  </p>
                </div>
              </div>
              <div className="timeline-event">
                <div className="timeline-event-marker">
                  <div className="timeline-event-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7l-7 7"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="timeline-event-content">
                  <div className="timeline-event-time">
                    <span>Week 3-5</span>
                  </div>
                  <h3 className="timeline-event-title">
                    Discovery &amp; Assessment
                  </h3>
                  <p className="timeline-event-description">
                    Control inventory, stakeholder interviews, system
                    walkthroughs, and evidence collection across all Trust
                    Service Criteria domains.
                  </p>
                </div>
              </div>
              <div className="timeline-event">
                <div className="timeline-event-marker">
                  <div className="timeline-event-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7l-7 7"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="timeline-event-content">
                  <div className="timeline-event-time">
                    <span>Week 6-8</span>
                  </div>
                  <h3 className="timeline-event-title">
                    Gap Analysis &amp; Reporting
                  </h3>
                  <p className="timeline-event-description">
                    Control effectiveness testing, gap identification, risk
                    assessment, and delivery of comprehensive findings report
                    with remediation recommendations.
                  </p>
                </div>
              </div>
              <div className="timeline-event">
                <div className="timeline-event-marker">
                  <div className="timeline-event-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7l-7 7"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="timeline-event-content">
                  <div className="timeline-event-time">
                    <span>Week 9-12</span>
                  </div>
                  <h3 className="timeline-event-title">Remediation Support</h3>
                  <p className="timeline-event-description">
                    Implementation guidance, control design assistance, policy
                    development, and validation testing to close identified gaps
                    before formal audit.
                  </p>
                </div>
              </div>
              <div className="timeline-event">
                <div className="timeline-event-marker">
                  <div className="timeline-event-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7l-7 7"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="timeline-event-content">
                  <div className="timeline-event-time">
                    <span>Week 13-14</span>
                  </div>
                  <h3 className="timeline-event-title">Pre-Audit Readiness</h3>
                  <p className="timeline-event-description">
                    Final readiness validation, evidence package preparation,
                    management assertion review, and auditor coordination to
                    ensure smooth examination process.
                  </p>
                </div>
              </div>
              <div className="timeline-event">
                <div className="timeline-event-marker">
                  <div className="timeline-event-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                        <path d="m9 12l2 2l4-4"></path>
                      </g>
                    </svg>
                  </div>
                </div>
                <div className="timeline-event-content">
                  <div className="timeline-event-time">
                    <span>Week 15-16</span>
                  </div>
                  <h3 className="timeline-event-title">
                    Audit &amp; Ongoing Monitoring
                  </h3>
                  <p className="timeline-event-description">
                    Support through formal SOC audit, report issuance, and
                    transition to continuous monitoring program for sustained
                    compliance posture maintenance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="framework-mapping-section">
        <div className="framework-mapping-container">
          <div className="framework-mapping-header">
            <h2 className="section-title">
              SOC Framework &amp; Standards Mapping
            </h2>
            <p className="section-subtitle">
              Our approach provides explicit traceability between SOC Trust
              Service Criteria and complementary regulatory frameworks, enabling
              unified compliance management across multiple standards.
            </p>
          </div>
          <div className="framework-mapping-table-wrapper">
            <table className="framework-mapping-table">
              <thead>
                <tr>
                  <th>
                    <span>SOC Trust Service Criteria</span>
                  </th>
                  <th>
                    <span>SOC 2 Reference</span>
                  </th>
                  <th>
                    <span>SOC 3 Coverage</span>
                  </th>
                  <th>
                    <span>ISO 27001 Mapping</span>
                  </th>
                  <th>
                    <span>NIST CSF Alignment</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Security - Common Criteria
                    </span>
                  </td>
                  <td>
                    <span>CC1.1 - CC9.2</span>
                  </td>
                  <td>
                    <span>Full Coverage</span>
                  </td>
                  <td>
                    <span>A.5 - A.18 (Multiple)</span>
                  </td>
                  <td>
                    <span>ID, PR, DE, RS, RC</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Security - Access Control
                    </span>
                  </td>
                  <td>
                    <span>CC6.1 - CC6.8</span>
                  </td>
                  <td>
                    <span>Included</span>
                  </td>
                  <td>
                    <span>A.9 Access Control</span>
                  </td>
                  <td>
                    <span>PR.AC, PR.PT</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Security - Change Management
                    </span>
                  </td>
                  <td>
                    <span>CC8.1 - CC8.5</span>
                  </td>
                  <td>
                    <span>Included</span>
                  </td>
                  <td>
                    <span>A.12.1, A.14.2</span>
                  </td>
                  <td>
                    <span>PR.IP</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Availability - System Operations
                    </span>
                  </td>
                  <td>
                    <span>A1.1 - A1.3</span>
                  </td>
                  <td>
                    <span>Summary Level</span>
                  </td>
                  <td>
                    <span>A.12.1, A.17.1</span>
                  </td>
                  <td>
                    <span>PR.IP, RC.RP</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Availability - Monitoring
                    </span>
                  </td>
                  <td>
                    <span>A1.2, CC7.1 - CC7.5</span>
                  </td>
                  <td>
                    <span>Summary Level</span>
                  </td>
                  <td>
                    <span>A.12.4, A.16.1</span>
                  </td>
                  <td>
                    <span>DE.AE, DE.CM</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Processing Integrity - Data Quality
                    </span>
                  </td>
                  <td>
                    <span>PI1.1 - PI1.5</span>
                  </td>
                  <td>
                    <span>Summary Level</span>
                  </td>
                  <td>
                    <span>A.12.2, A.12.3</span>
                  </td>
                  <td>
                    <span>PR.DS, DE.DP</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Confidentiality - Encryption
                    </span>
                  </td>
                  <td>
                    <span>C1.1 - C1.2, CC6.6</span>
                  </td>
                  <td>
                    <span>Summary Level</span>
                  </td>
                  <td>
                    <span>A.10.1 Cryptographic Controls</span>
                  </td>
                  <td>
                    <span>PR.DS-1, PR.DS-2</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Privacy - Collection &amp; Use
                    </span>
                  </td>
                  <td>
                    <span>P1.1 - P4.3</span>
                  </td>
                  <td>
                    <span>Not Included</span>
                  </td>
                  <td>
                    <span>A.18 (GDPR Annex)</span>
                  </td>
                  <td>
                    <span>PR.IP-3, PR.PT-2</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Privacy - Data Subject Rights
                    </span>
                  </td>
                  <td>
                    <span>P5.1 - P6.7</span>
                  </td>
                  <td>
                    <span>Not Included</span>
                  </td>
                  <td>
                    <span>A.18 (GDPR Annex)</span>
                  </td>
                  <td>
                    <span>PR.IP, PR.PT</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Security - Risk Assessment
                    </span>
                  </td>
                  <td>
                    <span>CC3.1 - CC3.4</span>
                  </td>
                  <td>
                    <span>Included</span>
                  </td>
                  <td>
                    <span>A.6.1.2, A.12.6</span>
                  </td>
                  <td>
                    <span>ID.RA, ID.RM</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Security - Incident Response
                    </span>
                  </td>
                  <td>
                    <span>CC7.3 - CC7.5</span>
                  </td>
                  <td>
                    <span>Included</span>
                  </td>
                  <td>
                    <span>A.16 Incident Management</span>
                  </td>
                  <td>
                    <span>RS.RP, RS.CO, RS.AN</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="framework-badge">
                      Security - Vendor Management
                    </span>
                  </td>
                  <td>
                    <span>CC9.1 - CC9.2</span>
                  </td>
                  <td>
                    <span>Included</span>
                  </td>
                  <td>
                    <span>A.15 Supplier Relationships</span>
                  </td>
                  <td>
                    <span>ID.SC, PR.IP</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="framework-mapping-note">
            <p>
              <span className="soc-compliance-text236">Note:</span>
              <span>
                {' '}
                SOC 2 Type II requires operating effectiveness testing over a
                minimum 3-month period. SOC 3 provides summary-level assurance
                suitable for public distribution. Our mapping ensures alignment
                with ISO 27001:2022 and NIST Cybersecurity Framework v2.0.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </p>
          </div>
        </div>
      </section>
      <section className="cta-split-section">
        <div className="soc-compliance-thq-cta-split-wrapper-elm cta-split-wrapper">
          <div className="soc-compliance-thq-cta-split-column-elm cta-split-column cta-split-secondary">
            <div className="cta-split-content">
              <div className="cta-split-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <h2 className="cta-split-title">
                Talk to a SOC Compliance Expert
              </h2>
              <p className="cta-split-description">
                Connect with our certified SOC consultants to discuss your
                specific compliance requirements, timeline constraints, and
                organizational challenges. We provide tailored guidance for your
                unique situation.
              </p>
              <div className="cta-split-features">
                <div className="cta-split-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                  <span>SOC 2 Type II certified team</span>
                </div>
                <div className="cta-split-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                  <span>Industry-specific expertise</span>
                </div>
                <div className="cta-split-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                  <span>Flexible engagement models</span>
                </div>
              </div>
            </div>
            <a href="#contact-expert">
              <div className="soc-compliance-thq-btn-elm3 btn-primary btn-xl btn">
                <span>Schedule Consultation</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <div className="soc-compliance-container2">
        <div className="soc-compliance-container3">
          <Script
            html={`<script defer data-name="testimonials-rail-scroll">
(function(){
  const rail = document.querySelector(".testimonials-rail")
  const prevBtn = document.querySelector(".testimonial-nav-prev")
  const nextBtn = document.querySelector(".testimonial-nav-next")

  if (rail && prevBtn && nextBtn) {
    const scrollAmount = 500

    prevBtn.addEventListener("click", () => {
      rail.scrollBy({
        left: -scrollAmount,
        behavior: "smooth",
      })
    })

    nextBtn.addEventListener("click", () => {
      rail.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      })
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default SOCCompliance
